import { writable, derived, get } from "svelte/store";
export const qModes = [
    { text: "Any", value: "" },
    { text: "Title", value: "intitle:" },
    { text: "Author", value: "inauthor:" },
    { text: "Publisher", value: "inpublisher:" },
    { text: "ISBN", value: "isbn:" },
];
export const orderBys = ["relevance", "newest"];
const store = writable({
    totalItems: 0,
    items: [],
    fetching: false,
    params: {
        keyword: "",
        orderBy: orderBys[0],
        page: 0,
        pageSize: 20,
        qMode: qModes[0].value,
    },
});
const request = ({ keyword, orderBy, page, pageSize, qMode }) => fetch("https://www.googleapis.com/books/v1/volumes" +
    `?q=${qMode}${keyword}&orderBy=${orderBy}` +
    `&maxResults=${pageSize}&startIndex=${page * pageSize}`).then((data) => data.json());
export const fetchBooks = async (params) => {
    store.update((value) => (Object.assign(Object.assign({}, value), { fetching: true, params: Object.assign(Object.assign({}, value.params), params) })));
    const res = await request(get(store).params);
    store.update((value) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, value), { totalItems: (_a = res.totalItems) !== null && _a !== void 0 ? _a : 0, items: (_b = res.items) !== null && _b !== void 0 ? _b : [], fetching: false }));
    });
    if (process.env.isDev) {
        // ストレージに保存
        sessionStorage.setItem("SEARCH", JSON.stringify(get(store)));
    }
};
if (process.env.isDev) {
    // ストレージから復元
    store.update((value) => (Object.assign(Object.assign({}, value), JSON.parse(sessionStorage.getItem("SEARCH")))));
}
// readonly で export
export const totalItems = derived(store, (v) => v.totalItems);
export const books = derived(store, (v) => v.items);
export const params = derived(store, (v) => v.params);
export const fetching = derived(store, (v) => v.fetching);
